// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1533":"54e1b614","2717":"54e1b614","2917":"54e1b614","3336":"54e1b614","8786":"54e1b614","9163":"54e1b614"}[chunkId] + ".chunk.css";
};